export default {"src":"/sg/_next/static/media/weddingplannerpro_inco3.425d575f.svg","height":78,"width":75,"blurWidth":0,"blurHeight":0};